module.exports = __webpack_public_path__ + "static/media/9.cb98aee4.jpg";